import { _decorator, Vec2 } from 'cc';
import PositionLRTBProvider from './PositionLRTBProvider';
import ShaderManipulator from './ShaderManipulator';
import UVLRTBProvider from './UVLRTBProvider';

const { ccclass, property, requireComponent } = _decorator;

@ccclass('UVMovingEffect')
@requireComponent(UVLRTBProvider)
@requireComponent(PositionLRTBProvider)
export default class UVMovingEffect extends ShaderManipulator {
    @property
    private _speed: Vec2 = new Vec2(0, 0);

    @property
    private _smooth: number = 0.2;

    @property
    private _up: number = 0.5;

    @property
    private _down: number = 0.5;

    @property
    private _left: number = 0.5;

    @property
    private _right: number = 0.5;

    @property
    public get speed() {
        return this._speed;
    }
    public set speed(value: Vec2) {
        if (this._speed.equals(value)) {
            return;
        }
        this._speed = value;
        this.updateSpeedProperty();
    }

    @property
    public get smooth() {
        return this._smooth;
    }
    public set smooth(value: number) {
        if (this._smooth === value) {
            return;
        }
        this._smooth = value;
        this.updateSmoothProperty();
    }

    @property
    public get up() {
        return this._up;
    }
    public set up(value: number) {
        if (this._up === value) {
            return;
        }
        this._up = value;
        this.updateUpProperty();
    }

    @property
    public get down() {
        return this._down;
    }
    public set down(value: number) {
        if (this._down === value) {
            return;
        }
        this._down = value;
        this.updateDownProperty();
    }

    @property
    public get left() {
        return this._left;
    }
    public set left(value: number) {
        if (this._left === value) {
            return;
        }
        this._left = value;
        this.updateLeftProperty();
    }

    @property
    public get right() {
        return this._right;
    }
    public set right(value: number) {
        if (this._right === value) {
            return;
        }
        this._right = value;
        this.updateRightProperty();
    }

    protected onLoad() {
        // for backward compatibility
        if (!this.getComponent(UVLRTBProvider)) {
            this.node.addComponent(UVLRTBProvider);
        }
        if (!this.getComponent(PositionLRTBProvider)) {
            this.node.addComponent(PositionLRTBProvider);
        }
    }

    protected syncProperty() {
        this.updateSpeedProperty();
        this.updateSmoothProperty();
        this.updateUpProperty();
        this.updateDownProperty();
        this.updateLeftProperty();
        this.updateRightProperty();
    }

    protected updateSpeedProperty() {
        const pass = this.targetPass;
        if (!pass) {
            return;
        }
        pass.setUniform(pass.getHandle('speed'), this.speed);
    }

    protected updateSmoothProperty() {
        const pass = this.targetPass;
        if (!pass) {
            return;
        }
        pass.setUniform(pass.getHandle('uSmooth'), this.smooth);
    }

    protected updateUpProperty() {
        const pass = this.targetPass;
        if (!pass) {
            return;
        }
        pass.setUniform(pass.getHandle('uUp'), this.up);
    }

    protected updateDownProperty() {
        const pass = this.targetPass;
        if (!pass) {
            return;
        }
        pass.setUniform(pass.getHandle('uDown'), this.down);
    }

    protected updateLeftProperty() {
        const pass = this.targetPass;
        if (!pass) {
            return;
        }
        pass.setUniform(pass.getHandle('uLeft'), this.left);
    }

    protected updateRightProperty() {
        const pass = this.targetPass;
        if (!pass) {
            return;
        }
        pass.setUniform(pass.getHandle('uRight'), this.right);
    }
}
